import { render, staticRenderFns } from "./HeroesSidePicksHero.vue?vue&type=template&id=e88fcc90&"
import script from "./HeroesSidePicksHero.vue?vue&type=script&lang=js&"
export * from "./HeroesSidePicksHero.vue?vue&type=script&lang=js&"
import style0 from "./HeroesSidePicksHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports